<template>
  <el-dialog
    :title="$t('shopCommunityManage.editShopCommunity')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form label-width="120px">
      <el-form-item :label="$t('shopCommunityManage.community')">
        <el-select
          v-model="editShopCommunityInfo.communityId"
          :placeholder="$t('shopCommunityManage.selectCommunityRequired')"
          style="width:100%"
        >
          <el-option
            label="首页目录"
            value="120406"
          />
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        <i class="el-icon-close"></i> {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="editShopCommunity">
        <i class="el-icon-check"></i> {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateShopCommunity } from '@/api/goods/shopCommunityApi'

export default {
  name: 'EditShopCommunity',
  data() {
    return {
      dialogVisible: false,
      editShopCommunityInfo: {
        scId: '',
        communityId: ''
      }
    }
  },
  methods: {
    open(data) {
      this.dialogVisible = true
      this.editShopCommunityInfo = { ...data }
    },
    handleClose() {
      this.editShopCommunityInfo = {
        scId: '',
        communityId: ''
      }
    },
    async editShopCommunity() {
      if (!this.editShopCommunityInfo.communityId) {
        this.$message.warning(this.$t('shopCommunityManage.selectCommunityRequired'))
        return
      }

      try {
        await updateShopCommunity(this.editShopCommunityInfo)
        this.$message.success(this.$t('common.saveSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('修改失败:', error)
        this.$message.error(error.message || this.$t('common.saveFailed'))
      }
    }
  }
}
</script>